// extracted by mini-css-extract-plugin
export default {"table":"styles_table__PgvRY","button":"styles_button__FKVj+","select":"styles_select__aATuU","title":"styles_title__G4VZz"};